import { createFileRoute } from "@tanstack/react-router";

import { MyBirdie } from "@/features/my/birdie";

export const Route = createFileRoute("/(member)/(protected)/my/birdie")({
  component: MyBirdie,
});
